import Header from "./Header";
import Loading from "./Loading";
import {useEffect, useState} from "react";
import {Download, Grid, List} from "lucide-react";
import {fetchUserSettings, saveUserSettings} from "../service/UserSettingsService";

const selectedBorder = 'solid black 3px';
const unSelectedBorder = 'solid black 1px';

function DashboardSettings() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [userSettings, setUserSettings] = useState({
        notifications: false,
        storeManuscripts: false,
        view: 'list'
    });
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        setLoading(true);
        setError(false);
        setSaved(false);
        fetchUserSettings(true)
            .then(response => {
                if (response.settings) {
                    setUserSettings(response.settings);
                } else {
                    setError(true);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    const handleCheckboxChange = (field) => {
        setUserSettings(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const handleViewChange = (viewType) => {
        setUserSettings(prev => ({
            ...prev,
            view: viewType
        }));
    };

    const handleSave = () => {
        setLoading(true);
        setError(false);
        setSaved(false);
        saveUserSettings(userSettings, true)
            .then(response => {
                if (response.settings) {
                    setUserSettings(response.settings);
                    setSaved(true);
                } else {
                    setError(true);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    return (
        <div>
            <Header page="dashboard-settings" />
            {loading ? (
                <Loading />
            ) : (
                <div className="body">
                    <div className="heading">Settings</div>
                    {error &&
                        <div className={"certify-submitted-text"} style={{border: '2px solid red'}}>
                            <div>There was an error while saving your dashboard settings. Please try again later.</div>
                        </div>
                    }
                    {saved &&
                        <div className={"certify-submitted-text"} style={{border: '2px solid green', width: 'max-content', padding: '0 5px'}}>
                            <div>Settings Saved!</div>
                        </div>
                    }
                    <div className="sub-heading">Privacy</div>

                    {/* Notifications */}
                    <div className="settings-wrapper dashboard-row" style={{marginBottom: 0, border: 'none'}}>
                        <div className="export-bottom-switch-text">Allow Notifications</div>
                        <label className="switch export-bottom-switch">
                            <input
                                type="checkbox"
                                checked={userSettings.notifications}
                                onChange={() => handleCheckboxChange("notifications")}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>

                    {/* Store Manuscripts */}
                    <div className="settings-wrapper dashboard-row" style={{marginTop: 0}}>
                        <div className="export-bottom-switch-text">Store My Manuscripts</div>
                        <label className="switch export-bottom-switch">
                            <input
                                type="checkbox"
                                checked={userSettings.storeManuscripts}
                                onChange={() => handleCheckboxChange("storeManuscripts")}
                            />
                            <span className="slider round"></span>
                        </label>
                        <div className="settings-text">
                            *This allows you to download your manuscripts at a later date.
                        </div>
                        <div className="settings-text">
                            *Manuscripts with high scores may be subject to professional review.
                        </div>
                    </div>

                    {/* View Options */}
                    <div className="sub-heading">View</div>
                    <div className="search-bar-wrapper dashboard-row">
                        <div
                            className="submissions-input-half submissions-input-half-first hover-grey"
                            style={{border: userSettings.view === "list" ? selectedBorder : unSelectedBorder}}
                            onClick={() => handleViewChange("list")}
                        >
                            <span className="export-icon" style={{marginTop: '1px'}}><List /></span>
                            <span className="export-dropdown-text">List</span>
                        </div>
                        <div
                            className="submissions-input-half hover-grey"
                            style={{border: userSettings.view === "grid" ? selectedBorder : unSelectedBorder}}
                            onClick={() => handleViewChange("grid")}
                        >
                            <span className="export-icon" style={{marginTop: '1px'}}><Grid /></span>
                            <span className="export-dropdown-text">Grid</span>
                        </div>
                    </div>

                    <button className="submit fade-in" onClick={handleSave}>
                        Save Settings
                    </button>
                </div>
            )}
        </div>
    );
}

export default DashboardSettings;
